module.exports = __webpack_public_path__ + "img/HC1026-01.36345f4f.jpg";